import type { RouterRootContext } from '@/router'
import { GlobalErrorPage } from '@/components/ui/errors'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { object, optional, pipe, startsWith, string } from 'valibot'

const searchSchema = object({
  next: optional(pipe(string(), startsWith('/'))),
})

export const Route = createFileRoute('/auth/')({
  component: Outlet,
  validateSearch: searchSchema,
  errorComponent: GlobalErrorPage,
  beforeLoad: (ctx) => {
    const context = ctx.context as RouterRootContext
    if (context.isAuthenticated) throw redirect({ to: ctx.search.next || '/' })
    throw redirect({ to: '/auth/login', search: { next: ctx.search.next } })
  },
})
